import React from 'react'
import Banner from '../images/illustration-working.svg'

function Home() {
  return (
    <div className='container py-16'>
        <div className="flex flex-col sm:flex-row">
            <div className="flex-1 px-4 sm:px-16 py-16 text-center sm:text-left">
                <h1 className="text-3xl sm:text-7xl font-bold">More than just</h1>
                <h1 className="text-2xl sm:text-7xl font-bold">shortner links</h1>
                <p className='py-4 text-xl sm:text-2xl'>Build your brand recognition and get detailed <br /> insights on how your links are performing.</p>
                <button className='rounded-full bg-cyan px-8 py-2 text-white'>Get started</button>
            </div>
            <div className="flex-1 py-2 lg:py-12 px-2 sm:px-0">
                <img src={Banner} alt="" className='img-fluid' />
            </div>
        </div>
    </div>
  )
}

export default Home